import { render, staticRenderFns } from "./TrTextAreaOnBackgroundV2.vue?vue&type=template&id=37aa7754&scoped=true&"
import script from "./TrTextAreaOnBackgroundV2.vue?vue&type=script&lang=js&"
export * from "./TrTextAreaOnBackgroundV2.vue?vue&type=script&lang=js&"
import style0 from "./TrTextAreaOnBackgroundV2.vue?vue&type=style&index=0&id=37aa7754&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37aa7754",
  null
  
)

export default component.exports